import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import classNames from "classnames";
import { NavLink } from "react-router-dom";
import "../Navigation.scss";
import FontAwesomeIcon from "../../Icon";
import { fetchInboxList } from "../../../store/actions/Inbox";

export const InboxLink = ({ link, collapseSideBar }) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth?.user || {});
  useEffect(() => {
    if (!user) return;
    dispatch(fetchInboxList(user.id, user.roles[0].role.name, "", false));
  }, [dispatch, user]);
  const inboxCount = useSelector((state) => {
    return (
      state?.inbox?.inboxList?.filter((listItem) => !listItem.isRead && user.id !== listItem.sentBy).length ||
      0
    );
  });

  return (
    <li
      title={link.label}
      className="navigation__link"
      key={`nav-link-${link.label}`}
    >
      <NavLink
        to={link.path}
        className={classNames("navigation__anchor", {
          "navigation__anchor--collapsed": collapseSideBar,
        })}
        activeClassName="navigation__anchor--active"
      >
        <FontAwesomeIcon weight="light" glyph={link.icon} />
        <div
          className={classNames("navigation__anchor--label", {
            "navigation__anchor--label--collapse": collapseSideBar,
          })}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            paddingRight: "1rem",
          }}
        >
          <span>{link.label}</span>
          {inboxCount > 0 && (
            <span
              style={{
                backgroundColor: "#00000066",
                color: "#FFFFFF",
                borderRadius: "1rem",
                padding: "0.3rem 0.7rem",
              }}
            >
              {inboxCount}
            </span>
          )}
        </div>
      </NavLink>
    </li>
  );
};
